import { Box, Flex } from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import "@livekit/components-styles";
import {
  ControlBar,
  GridLayout,
  LiveKitRoom,
  ParticipantTile,
  RoomAudioRenderer,
  VideoConference,
} from "@livekit/components-react";
import HostControls from "../components/livekit/host-controls";
import Chat from "../components/livekit/host-chat";

function Host() {
  let { id } = useParams();
  const serverUrl = "wss://pindodg-g5szeweq.livekit.cloud";
  const token =
    "eyJhbGciOiJIUzI1NiJ9.eyJ2aWRlbyI6eyJyb29tSm9pbiI6dHJ1ZSwiY2FuUHVibGlzaCI6dHJ1ZSwiY2FuUHVibGlzaERhdGEiOnRydWUsInJvb20iOiJtZWV0dXAifSwiaXNzIjoiQVBJSk5vV0d0QjJ5WGdBIiwiZXhwIjoxNzA5NjE0MjQwLCJuYmYiOjAsInN1YiI6Imhvc3QifQ.t8FhL_U8iSnwEmn8F8OeY14jjepGZEoexFnE3L0PU7o";
  return (
    <Box backgroundColor={"white"} h={"100vh"} overflowY={"hidden"}>
      <LiveKitRoom
        video={true}
        audio={true}
        token={token}
        serverUrl={serverUrl}
        // Use the default LiveKit theme for nice styles.
        data-lk-theme="default"
        style={{ height: "100vh" }}
      >
        <Box>
          <HostControls slug={"meetup"} />
        </Box>

        <Box>
          <Chat />
        </Box>
      </LiveKitRoom>
    </Box>
  );
}

export default Host;
